export const TABLE_ROW_SIZE = 50;

export const MODAL_TOGGLE_TIME = 500;

export const STYLES = {
    MIN_WIDTH_BTN: 150,
    INPUT_HEIGHT: 56
}